
























































import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import AdminCustomerIdDetail from "@/components/admin/adminCustomerIdDetail.vue";
import { Component, Vue } from "vue-property-decorator";
import PaginateModel from "@/model/paginate";
import AdminCustomerIdApi from "@/api/adminCustomerIdApi";
import MCartCustomer from "@/model/mCartcustomer";
import store from "@/store";

@Component({
  name: "adminCustomerIdList",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    AdminCustomerIdDetail,
  },
})
export default class adminCustomerIdList extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public adminCustomers: MCartCustomer[] = [];
  public searchParams = {
    keyword: "",
    sort: "customer_code",
    direction: "asc"
  };

  // コード	来歴	画像	カテゴリ	品名	製品説明
  public headers = [
    { id: "customer_code", name: "コード", order: "desc" },
    { id: "customer_name", name: "得意先名", order: "" },
    { id: "account_num", name: "アカウント数" },
    { id: "", name: "" },
  ];

  mounted() {
    this.parserQuery();
    this.filter();
  }

  public parserQuery() {
    let { query } = this.$router.currentRoute;
    this.searchParams = { ...this.searchParams, ...query };
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...query,
      ...this.searchParams,
      ...addition,
    };
    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any): void {
    store.dispatch("Router/setSearchParameters", {
      adminCustomer: { ...query },
    });
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query: any) {
    const result = await AdminCustomerIdApi.getAdminCustomerList(query);

    this.pagination = result.paginate;
    this.adminCustomers = result.list;
  }

  public detail(adminCustomer: MCartCustomer) {
    (this.$refs.adminCustomerIdDetail as AdminCustomerIdDetail).show(
      adminCustomer
    );
  }

  public resetSearch() {
    this.searchParams = {
      keyword: "",
      sort: "customer_code",
      direction: "asc"
    };
    this.filter(true);
  }
}
